export enum StakeModifier {
    plus = "plus",
    minus = "minus"
}

export enum PriceStatusClass {
    periodOver = "over",
    periodResulting = "resulting",
    periodCurrent = "current",
    periodPre = "not-started"
}